import { EnumValue } from '@/Data/typesV2'
import { getLocalizedSchemaEnumValues } from '@/utils/schemaLocalization'

export const getEnumDisplayValue = (
  attributeEnumValues?: EnumValue[],
  attributeValue?: unknown,
) => {
  const localizedEnumValues = getLocalizedSchemaEnumValues(attributeEnumValues)
  if (Array.isArray(attributeValue)) {
    const enumValues = localizedEnumValues?.filter((el) =>
      attributeValue.includes(el.value),
    )

    return enumValues?.map((e) => e.title)
  }

  const enumValue = localizedEnumValues?.find(
    (attributeEnumValue) => attributeEnumValue.value === attributeValue,
  )

  return enumValue?.title
}
